module.exports = __webpack_public_path__ + "media/brands/niewiadow-e4a47d7b.png";